import { render, staticRenderFns } from "./CommentManage.vue?vue&type=template&id=97e623b2&scoped=true"
import script from "./CommentManage.vue?vue&type=script&lang=js"
export * from "./CommentManage.vue?vue&type=script&lang=js"
import style0 from "./CommentManage.vue?vue&type=style&index=0&id=97e623b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e623b2",
  null
  
)

export default component.exports